export const measures = [
  {
    id: 1,
    name: 'Social distancing'
  },
  {
    id: 2,
    name: 'Stay at home orders'
  },
  {
    id: 3,
    name: 'Restaurants close'
  },
  {
    id: 4,
    name: 'Amateur sports not allowed'
  }
];